import LanhDaoGiaoViecPU from './LanhDaoGiaoViecPU.jsx';
import TruongPhongGiaoViecPU from './TruongPhongGiaoViecPU.jsx';
import ThuHoiPU from './ThuHoiPU.jsx';
import LanhDaoGiaoViecKTDXPU from './LanhDaoGiaoViecKTDXPU.jsx';
import LanhDaoGiaoViecTTXMPU from './LanhDaoGiaoViecTTXMPU.jsx';
import ThuHoiGQ from './ThuHoiGQ.jsx';

export {
  LanhDaoGiaoViecPU,
  TruongPhongGiaoViecPU,
  ThuHoiPU,
  LanhDaoGiaoViecKTDXPU,
  LanhDaoGiaoViecTTXMPU,
  ThuHoiGQ
}


// WEBPACK FOOTER //
// ./src/components/modules/dialog/thu-hoi-form/index.js